__turbopack_context__.v({
  "LRIcon": "Discount-module__pPk2Qa__LRIcon",
  "amazing": "Discount-module__pPk2Qa__amazing",
  "name": "Discount-module__pPk2Qa__name",
  "nameMobile": "Discount-module__pPk2Qa__nameMobile",
});
